import axios from 'axios';
import {backendHost} from '../../config';

export const updateMailing = (params) => {
    return axios.put(`${backendHost}/api/admin/v2/mailing`, params);
};